import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {HubProcess, HubSession} from '../../model/hub-session';
import {HubApiService} from '../../services/hub-api.service';
import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js';
@Component({
  selector: 'hub-processes',
  imports: [FormsModule, RouterLink],
  templateUrl: './processes.component.html',
  styleUrl: './processes.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProcessesComponent implements OnInit {
  processes: HubProcess[] = [];
  session: HubSession | null = null;
  newProcessName = '';
  createModalOpen = false;
  peerEnvironment: 'prod' | 'test' = 'test';
  loading = true;
  error = '';
  success = '';

  constructor(private hubApi: HubApiService) {
  }

  ngOnInit(): void {
    this.session = this.hubApi.currentSession;
    this.hubApi.session$.subscribe((session) => this.session = session);
    this.reload();
  }

  createProcess(): void {
    const name = this.newProcessName.trim();
    if (!name) return;
    this.clearMessages();
    this.hubApi.createProcess(name).subscribe({
      next: (response) => {
        this.processes = response.processes;
        this.peerEnvironment = response.peerEnvironment;
        this.newProcessName = '';
        this.createModalOpen = false;
        this.success = this.t('HubProcessCreatedMessage');
      },
      error: (error) => this.error = error.error?.message || this.t('HubProcessCreateFailedMessage')
    });
  }

  copyToPeer(process: HubProcess): void {
    const message = this.t('HubCopyProcessConfirmation')
      .replace('{process}', process.name)
      .replace('{environment}', this.peerEnvironment);
    if (!confirm(message)) return;
    this.clearMessages();
    this.hubApi.copyProcessToPeer(process.processDefinitionId).subscribe({
      next: (response) => {
        this.processes = response.processes;
        this.peerEnvironment = response.peerEnvironment;
        this.success = this.t('HubProcessCopiedMessage').replace('{environment}', this.peerEnvironment);
      },
      error: (error) => this.error = error.error?.message || this.t('HubProcessCopyFailedMessage')
    });
  }

  copyButtonLabel(): string {
    return this.t(this.peerEnvironment === 'prod' ? 'CopyToProd' : 'CopyToTest');
  }

  closeCreateModal(): void {
    this.createModalOpen = false;
    this.newProcessName = '';
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }

  private reload(): void {
    this.hubApi.listProcesses().subscribe({
      next: (response) => {
        this.processes = response.processes;
        this.peerEnvironment = response.peerEnvironment;
        this.loading = false;
      },
      error: (error) => {
        this.error = error.error?.message || this.t('HubProcessesLoadFailedMessage');
        this.loading = false;
      }
    });
  }

  private clearMessages(): void {
    this.error = '';
    this.success = '';
  }
}
